import React, { Component } from "react";
import PropTypes from "prop-types";
import { Mutation } from "react-apollo";
import { Fieldset } from "rbx";
import { EditFormButtonGroup } from "../inputs";

import {
  UPDATE_LOCATION_CONTACT_MUTATION,
  DELETE_LOCATION_CONTACT_MUTATION
} from "../../graphql/Locations/LocationContacts.graphql";

import Section from "../Section";

import { ErrorMessage } from "../ErrorMessage";

import LocationContactForm from "./LocationContactForm";

class EditLocationContactForm extends Component {
  state = {
    IsPrimary: false,
    Description: "",
    Name: "",
    Telephone: "",
    Extension: "",
    FaxNo: "",
    Email: "",
    Active: true,
    ...this.props.contact
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  render() {
    const { id, onComplete } = this.props;
    const {
      IsPrimary,
      Description,
      Name,
      Telephone,
      Extension,
      FaxNo,
      Email,
      Active
    } = this.state;
    // console.log(IsPrimary);
    return (
      <Mutation
        mutation={UPDATE_LOCATION_CONTACT_MUTATION}
        variables={{
          data: {
            LocationRecIdRef: id,
            IsPrimary,
            Description,
            Name,
            Telephone,
            Extension,
            FaxNo,
            Email,
            Active
          },
          where: {
            RecId: parseInt(this.props.contact.RecId)
          }
        }}
      >
        {(updateLocationContact, { loading, error }) => (
          <Section title="Edit Location Contact">
            <form
              id="edit-location-contact"
              onSubmit={async e => {
                e.preventDefault();
                await updateLocationContact();
                onComplete();
              }}
            >
              <ErrorMessage error={error} />
              <Fieldset disabled={loading}>
                <LocationContactForm
                  inputs={{
                    LocationRecIdRef: id,
                    IsPrimary,
                    Description,
                    Name,
                    Telephone,
                    Extension,
                    FaxNo,
                    Email,
                    Active
                  }}
                  onChange={this.onChange}
                />
                <EditFormButtonGroup
                  deleteMutation={DELETE_LOCATION_CONTACT_MUTATION}
                  form="edit-location-contact"
                  refetchQueries={["ALL_LOCATION_CONTACTS_QUERY"]}
                  variables={{
                    where: { RecId: parseInt(this.props.contact.RecId) }
                  }}
                  onComplete={onComplete}
                />
              </Fieldset>
            </form>
          </Section>
        )}
      </Mutation>
    );
  }
}

EditLocationContactForm.propTypes = {
  id: PropTypes.number.isRequired,
  onComplete: PropTypes.func,
  contact: PropTypes.object.isRequired
};
export default EditLocationContactForm;
